export default __webpack_public_path__ + "img/jtc/jtc2_1500.webp";